import { commonFormatter, SharedFields } from "../../configs";
import { ScreenSectionConfigType } from "../../wf-difference.types";

const employmentIdField: ScreenSectionConfigType = {
  field: "employmentId",
  view: "normal",
  label: "ai_projects.agents.employment_id",
};

const isActiveField: ScreenSectionConfigType = {
  field: "isActive",
  view: "normal",
  label: "common.form.label.active",
  format: (data: { isActive: boolean }) => commonFormatter.matchTrueFalse(data?.isActive),
};

export const govAgentScreenConfig = {
  type: "gov-project",
  sections: [
    ...SharedFields.name,
    ...SharedFields.description,
    SharedFields.entityIdField,
    employmentIdField,
    isActiveField,
  ],
};
